import { z } from 'zod';
import { disallowedFileTypeMessage } from '../zod-helpers/disallowed-file-type-message.js';
import { fileTooLargeMessage } from '../zod-helpers/file-too-large-message.js';
import { PURCHASE_ORDER_FILE_ALLOWED_MIME_TYPES, PURCHASE_ORDER_FILE_MAX_BYTES, } from './file-constants.js';
const disallowedTypeMessage = disallowedFileTypeMessage(PURCHASE_ORDER_FILE_ALLOWED_MIME_TYPES);
const tooLargeMessage = fileTooLargeMessage(PURCHASE_ORDER_FILE_MAX_BYTES);
/** Normalize and reject obviously invalid base64; return null if invalid. */
export function normalizeUploadBase64(value) {
    const normalized = value.replace(/\s+/g, '');
    if (!normalized || normalized.length % 4 !== 0)
        return null;
    if (!/^[A-Za-z0-9+/]+={0,2}$/.test(normalized))
        return null;
    return normalized;
}
export function estimatedDecodedByteLength(normalizedBase64) {
    const padding = normalizedBase64.endsWith('==') ? 2 : normalizedBase64.endsWith('=') ? 1 : 0;
    return (normalizedBase64.length * 3) / 4 - padding;
}
export const uploadPurchaseOrderFileInputSchema = z
    .object({
    fileName: z
        .string()
        .trim()
        .min(1, 'File name is required.')
        .max(255)
        // WHY: Node's response.writeHead throws ERR_INVALID_CHAR for code points above U+00FF in
        // header values; reject at upload so the file is never stored in an unservable state.
        .regex(/^[\x20-\x7E\x80-\xFF]+$/, 'File name contains unsupported characters.'),
    mimeType: z.enum(PURCHASE_ORDER_FILE_ALLOWED_MIME_TYPES, disallowedTypeMessage),
    /** Caller-generated UUID used as a deduplication key so retries return the existing file. */
    clientUploadId: z.uuid({ version: 'v4' }).optional(),
    contentBase64: z
        .string()
        .min(1, 'File content is required.')
        // Reject whitespace-padded payloads before the replace() allocation in superRefine.
        .max(Math.ceil((PURCHASE_ORDER_FILE_MAX_BYTES * 4) / 3) + 100, tooLargeMessage),
})
    .superRefine((value, ctx) => {
    const normalized = normalizeUploadBase64(value.contentBase64);
    if (!normalized) {
        ctx.addIssue({
            code: 'custom',
            message: 'File content is invalid.',
            path: ['contentBase64'],
        });
        return;
    }
    const byteLength = estimatedDecodedByteLength(normalized);
    if (byteLength === 0) {
        ctx.addIssue({ code: 'custom', message: 'File is empty.', path: ['contentBase64'] });
        return;
    }
    if (byteLength > PURCHASE_ORDER_FILE_MAX_BYTES) {
        ctx.addIssue({
            code: 'custom',
            message: tooLargeMessage,
            path: ['contentBase64'],
        });
    }
});
//# sourceMappingURL=upload-file-input.js.map